import { Box } from "@mui/material";

export function SectionDivider() {
  return (
    <Box
      sx={(theme) => ({
        height: 1,
        backgroundColor: theme.palette.divider,
      })}
    />
  );
}
